import React from 'react';
import { Box, Typography } from '@mui/material';
import InboxIcon from '@mui/icons-material/Inbox';

const EmptyState = ({
  title = 'No Data Available',
  description = 'There are currently no records to display.',
  icon: Icon = InboxIcon,
  action = null
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      py={8}
      px={3}
      textAlign="center"
      sx={{ minHeight: '300px' }}
    >
      <Box
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.03)',
          borderRadius: '50%',
          p: 3,
          mb: 3,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Icon sx={{ fontSize: 64, color: 'rgba(255, 255, 255, 0.2)' }} />
      </Box>
      <Typography variant="h6" sx={{ color: '#fff', fontWeight: 600, mb: 1 }}>
        {title}
      </Typography>
      <Typography variant="body2" sx={{ color: '#8b8fa8', mb: 3, maxWidth: '400px' }}>
        {description}
      </Typography>
      {action && (
        <Box mt={2}>
          {action}
        </Box>
      )}
    </Box>
  );
};

export default EmptyState;
